import type { KeyboardEvent } from 'react'

// Enter sends on hardware keyboards; on touch screens it inserts a newline (the
// Send button sends), and it never fires mid-IME composition (ja/zh input).
export function isEnterToSend(e: KeyboardEvent<HTMLTextAreaElement>): boolean {
  if (e.key !== 'Enter' || e.shiftKey || e.nativeEvent.isComposing || e.keyCode === 229)
    return false
  return !window.matchMedia('(pointer: coarse)').matches
}
